import { onValue, ref } from 'firebase/database';
import { db } from './app';
import { requireUid } from './auth';
import { paths } from './paths';
import { removeValue, writeValue } from './rtdb';

/**
 * Les likes des lieux de l'onglet Lieux.
 *
 * Les lieux viennent d'Apple et ne sont pas dans la base : seul le like y est,
 * range sous leur identifiant. Comme ceux d'un post, ils se comptent en lisant
 * leurs cles, sans compteur a tenir.
 */

export interface LikesDuLieu {
  total: number;
  moi: boolean;
}

/*
  L'ecoute repond aussi a mon propre geste, sans attendre le serveur, et se
  ravise toute seule s'il refuse : le coeur n'a pas d'etat a lui.
*/
export function ecouterLesLikes(lieuId: string, onChange: (likes: LikesDuLieu) => void): () => void {
  const uid = requireUid();
  return onValue(
    ref(db(), paths.lieuLikes(lieuId)),
    (snap) => {
      const likes = (snap.val() as Record<string, true> | null) ?? {};
      onChange({ total: Object.keys(likes).length, moi: Boolean(likes[uid]) });
    },
    /* Illisibles : la fiche reste utile sans eux. */
    () => undefined,
  );
}

export function poserLeLike(lieuId: string, aime: boolean): Promise<void> {
  const chemin = paths.lieuLike(lieuId, requireUid());
  return aime ? writeValue(chemin, true) : removeValue(chemin);
}
